import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OauthService {
  private _http = inject(HttpClient);


  domain: string = environment.oauth.target
  token = {
    clientId: <string>environment.oauth.clientId,
    clientSecret: <string>environment.oauth.clientSecret,
    token: <any>{}
  }

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }


    /**
     * Gets the OAuth token
     */
    getToken() {

      this._http.post(`${this.domain}/oauth/token`, this.argBody, this.argHeaders).subscribe({
        next: (response) => {
          this.token.token = response
        },
        error: (e) => {
          console.error(e)
        }
      })
    }


  /**
   * Renews token, and stores it, then returns a token request
   */
  renewToken() {

    let body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', this.token.token.refreshToken)

  

    return this._http.post(`${this.domain}/oauth/token`, body, this.argHeaders)
      .pipe(tap((token) => {
        this.token.token = token
      }))
  }


  /**
   * Generic request-poster, that can contain anything in body with any target
   * 
   * Current targets available:
   * `/create/file`
   * 
   * @param requestTarget 
   * @param requestBody 
   */
  postRequest(requestTarget, requestBody) {

    // Token renewer
    if(new Date(this.token.token.accessTokenExpiresAt).getTime() < (new Date().getTime())) {

      this.renewToken().subscribe({
        complete: () => {
          this.postRequest(requestTarget, requestBody)
        }
      })
    }


    // Declare bearer header
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.token.token.accessToken}`
      })
    }
    
    // Post the request - should return once implemented fully rather than subscribe
    return this._http.post(`${this.domain}${requestTarget}`, requestBody, httpOptions)
  }


  private get argBody() {
    let body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', environment.oauth.username)
      .set('password', environment.oauth.password)

    return body
  }

  private get argHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Basic '+ btoa(this.token.clientId + ':' + this.token.clientSecret),
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    return httpOptions;
}
}
